




























































import Utils from "@/utils";
import Vue from "vue";

export default Vue.extend({
    name: "UserAvatar",
    props: {
        text: String,
        isAnonymousUser: Boolean,
        isLoading: Boolean,
        openMenu: Boolean
    },
    data: () => {
        return {};
    },
    components: {},
    created() {},
    computed: {
        initials() {
            let initials = "";

            if (!this.text) return "";

            this.text?.split(" ").forEach(x => {
                if (x != "") initials += x.charAt(0);
            });
            return initials.substring(0, 2).toUpperCase();
        },
        hasMenu(): Boolean {
            return !!this.$slots.default;
        }
    },
    methods: {
        handleUserAvatarClick() {
            if (this.hasMenu) this.$emit("user-avatar-click");
        }
    }
});
